import { motion } from "framer-motion";
import { Reveal, MaskLine } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Sourced, not settled",
    body: "We hunt for peak-season fruit and rich Belgian chocolate, then let the ingredient lead. If it isn't the best, it doesn't make the batch.",
  },
  {
    n: "02",
    title: "Slow-churned in small batches",
    body: "Crafted with low overrun for pure flavour. Skillfully churned to a texture that's dense, elastic, and impossibly smooth.",
  },
  {
    n: "03",
    title: "Nothing to hide",
    body: "No artificial colours and no synthetic flavours. Just milk, fruit, sugar and a little obsession.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      className="relative bg-bggreen py-28 lg:py-40 px-6 lg:px-10 scroll-mt-20"
      data-testid="manifesto-section"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="max-w-3xl mb-20">
          <Reveal>
            <p className="uppercase tracking-[0.3em] text-xs font-500 text-cocoa/50 mb-6">
              The craft — in three chapters
            </p>
          </Reveal>
          <h2 className="font-heading font-600 text-cocoa leading-[1.02] tracking-tight text-4xl sm:text-5xl lg:text-6xl">
            <MaskLine>How we make</MaskLine>
            <MaskLine delay={0.08}>gelato worth the wait.</MaskLine>
          </h2>
        </div>

        <div className="divide-y divide-cocoa/15 border-y border-cocoa/15">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.05 }}
              className="group grid md:grid-cols-12 gap-6 md:gap-10 py-12 items-start"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="md:col-span-2">
                <span className="font-heading font-600 text-6xl md:text-7xl text-cocoa/25 group-hover:text-pistachio transition-colors duration-500">
                  {c.n}
                </span>
              </div>
              <h3 className="md:col-span-4 font-heading font-500 text-2xl md:text-3xl text-cocoa tracking-tight">
                {c.title}
              </h3>
              <p className="md:col-span-6 text-cocoa/70 text-base sm:text-lg leading-relaxed max-w-xl">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
